import React from 'react';
import { Route, Switch } from 'react-router-dom';
import IntlComponent from 'axway-react-intl';
import Breadcrumbs from 'components/widgets/Breadcrumbs';
import { NotFound } from 'components/pages/error';
import { ProjectLayout } from 'components/pages/layout';
import PropTypes from 'prop-types';

class OnEnterWrapper extends React.Component {
	componentWillMount() {
		this.props.onEnter && this.props.onEnter(this.props);
	}

	componentWillReceiveProps(newProps) {
		if (newProps.location.key !== this.props.location.key) {
			newProps.onEnter && newProps.onEnter(newProps);
		}
	}

	render() {
		return <div>{ this.props.children }</div>;
	}
}

class Page extends React.Component {
	constructor(props) {
		super(props);
		IntlComponent.init(this);
	}

	render () {
		const { children } = this.props;
		return (
			<Switch>
				{ children }
				<PageRoute component={NotFound} />
			</Switch>
		);
	}
}
Page.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.array,
		PropTypes.object
	])
};

class PageRoute extends React.Component {
	render() {
		const {
			breadcrumbs,
			fullscreen,
			hasNav,
			component,
			render,
			onEnter,
			children,
			props,
			...rest
		} = this.props;
		const renderMethod = (params) => {
			const isFullScreen = (fullscreen && typeof fullscreen === 'function')
				? fullscreen(params) : fullscreen;
			const layout = (
				<ProjectLayout
					fullscreen={isFullScreen}
					hasNav={hasNav}
				>
					{ breadcrumbs && (
						<Breadcrumbs
							crumbs={
								typeof breadcrumbs === 'function'
									? breadcrumbs(params)
									: breadcrumbs
							}
						/>
					)}
					{ render && render(params)}
					{ component && React.createElement(component, { ...params, ...props })}
					{ children && typeof children === 'function' ? children(params) : children }
				</ProjectLayout>
			);
			if (onEnter) {
				return (
					<OnEnterWrapper
						onEnter={onEnter}
						{...params}
					>
						{layout}
					</OnEnterWrapper>
				);
			}
			return layout;
		};

		return (
			<Route render={renderMethod} {...rest} />
		);
	}
}

PageRoute.propTypes = {
	breadcrumbs: PropTypes.oneOfType([
		PropTypes.func,
		PropTypes.array
	]),
	fullscreen: PropTypes.oneOfType([
		PropTypes.func,
		PropTypes.bool
	]),
	render: PropTypes.func,
	onEnter: PropTypes.func,
	children: PropTypes.oneOfType([
		PropTypes.func,
		PropTypes.object
	]),
	props: PropTypes.object,
	rest: PropTypes.object
};

Page.Route = PageRoute;

export default Page;
